import React, { useEffect, useRef } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getDomDistance, getQuery } from '@src/utils/index';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

const Banner = () => {
    const imgRef = useRef();
    const bannerImgUrl = 'https://x0.ifengimg.com/ucms/2024_28/2B7429F69F82A0A20ED9EB4B1E82390D4D73890B_size1434_w750_h1524.png';

    useEffect(() => {
        const bannerImgObj = new Image();

        bannerImgObj.onload = () => {
            const fromWecom = getQuery(location.href, 'from_wecom');
            const domPageTop = getDomDistance(imgRef.current).top;

            if (domPageTop && fromWecom === '1') {
                window.scroll({ top: domPageTop, behavior: 'smooth' });
            }
        };

        bannerImgObj.src = bannerImgUrl;
    }, []);

    return (
        <div className={styles.banner}>
            <img
                src={bannerImgUrl}
                className={styles.banner1}
            />
            <div className={styles.bref}>
                <img
                    ref={imgRef} 
                    // src="https://x0.ifengimg.com/ucms/2024_29/D5512A9FF06295C9129AB7BFDBBDFC352773A906_size60_w670_h328.png"
                    src="https://x0.ifengimg.com/ucms/2024_45/CE05F01E56BE77C1DAB6ECCAB556A9A39F6FDD9A_size64_w670_h380.png"
                    className={styles.banner2}
                />
            </div>
        </div>
    );
};

export default errorBoundary(Banner);
